var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/background-shapes.tsx";
import classNames from 'clsx';
import React from 'react';

/** Gradient that appears in the background of the UI. */
const BackgroundShapes = _ref => {
  let {
    position = 'fixed'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(position, 'top-0 inset-x-0 flex justify-center overflow-hidden pointer-events-none'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-screen h-screen bg-gradient-sm lg:bg-gradient-light lg:dark:bg-gradient-dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }));
};

export default BackgroundShapes;